// 菜单组件

import { Menu } from 'antd';
import router_menu from '../../common/router_menu';

const { SubMenu } = Menu;

function App() {
  return (
    <div>
      <Menu mode="horizontal">
        {router_menu.map((item: any) => {
          if (!item.hidden) {
            if (item.children) {
              return < SubMenu key={item.route} title={<span>{item.icon}<span>{item.title}</span></span>}>
                {item.children.map((item: any) => <Menu.Item key={item.route}><span><a title={item.title} href={'/#' + item.route}>{item.title}</a></span></Menu.Item>)}
              </SubMenu>
            } else {
              return <Menu.Item key={item.route}>{item.icon}<span><a title={item.title} href={'/#' + item.route}>{item.title}</a></span></Menu.Item>
            }
          }
        })}
      </Menu >
    </div >
  )
}

export default App